import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { ProblemSection } from '../components/sales/ProblemSection';
import { ProductSection } from '../components/sales/ProductSection';
import { MechanismSection } from '../components/sales/MechanismSection';
import { AudienceSection } from '../components/sales/AudienceSection';
import { PricingSection } from '../components/sales/PricingSection';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-[#050505] text-[#f0f0f0] font-sans selection:bg-[#00d4aa] selection:text-black" data-id="element-116">
      <HeroSection data-id="element-117" />
      <ProblemSection data-id="element-118" />
      <ProductSection data-id="element-119" />
      <MechanismSection data-id="element-120" />
      <AudienceSection data-id="element-121" />
      <PricingSection data-id="element-122" />

      <footer className="py-12 text-center text-gray-600 text-sm bg-[#050505]" data-id="element-123">
        <p data-id="element-124">
          © {new Date().getFullYear()} Sistema Asistentes Listos. Todos los
          derechos reservados.
        </p>
      </footer>
    </main>;
}